import { useMemo } from 'react'
import { Activity } from '@user/features/Activity/typings'
import { useGetSalesTeamUsersOnMount } from '@user/store/salesTeam'
import { useFetchActivityTypesOnMount } from '../../../EditActivityPopover/EditActivityForm/hooks/useFetchActivityTypesOnMount'
import { useLocalizationDateFormat } from '@user/features/Localization/useLocalizationDateFormat'

export function useData(current: Activity) {
  useGetSalesTeamUsersOnMount(current?.salesTeamId)
  const { formatDate } = useLocalizationDateFormat()

  const { activityTypes } = useFetchActivityTypesOnMount()

  const activityType = useMemo(() => {
    return activityTypes.find((type) => type.id === current?.activityTypeId)
  }, [current, activityTypes])

  const dueDate = useMemo(
    () => formatDate(new Date(current?.dueDate || 0), 'MM/dd/yyyy - hh:mm aa'),
    [current, formatDate],
  )

  const startDate = useMemo(
    () =>
      current?.startDate
        ? formatDate(new Date(current.startDate), 'MM/dd/yyyy - hh:mm aa')
        : '',
    [current, formatDate],
  )

  const owner = useMemo(() => {
    if (current?.owner) {
      if (current.ownerIsActive === false) {
        return current.owner + ' (Inactive)'
      }
      return current.owner
    }
    return 'Unassigned'
  }, [current])

  return {
    owner,
    activityType,
    dueDate,
    startDate,
  }
}
